const zhTW = {
  common: {
    appName: '輿情監測系統',
    loading: '載入中...',
    noData: '暫無資料',
    confirm: '確定',
    cancel: '取消',
    save: '儲存',
    edit: '編輯',
    delete: '刪除',
    add: '新增',
    search: '搜尋',
    export: '匯出',
    back: '返回',
    next: '下一頁',
    prev: '上一頁',
    submit: '提交',
    reset: '重設',
    close: '關閉',
    all: '全部',
    total: '共',
    actions: '操作',
    status: '狀態',
    type: '類型',
    name: '名稱',
    time: '時間',
    operation: '操作',
    success: '成功',
    failed: '失敗',
    yes: '是',
    no: '否',
    page: '第',
    of: '頁 / 共',
    items: '筆',
    selectPlaceholder: '請選擇',
    inputPlaceholder: '請輸入',
    viewOriginal: '查看原文',
  },
  nav: {
    dashboard: '綜合看板',
    monitor: '監測管理',
    monitorManage: '監測管理',
    monitorData: '資料監測',
    analysis: '監測分析',
    volume: '聲量監測',
    publicOption: '事件分析',
    report: '分析報告',
    settings: '系統設定',
    settingsWarning: '預警設定',
    settingsWarningMsg: '預警訊息',
    settingsPreference: '偏好設定',
    settingsFeedback: '回饋建議',
  },
  login: {
    title: '登入',
    subtitle: '輿情監測系統',
    phone: '手機號碼',
    phonePlaceholder: '請輸入手機號碼',
    password: '密碼',
    passwordPlaceholder: '請輸入密碼',
    signIn: '登入',
    signingIn: '登入中...',
    logout: '登出',
    invalidCredentials: '手機號碼或密碼錯誤',
  },
  dashboard: {
    title: '綜合看板',
    todayStatus: '今日輿情情況',
    warningAlerts: '預警輿情',
    hotEvents: '熱點事件',
    hotSearch: '熱點搜尋詞',
    leadersOpinion: '領導人輿情',
    pushOpinion: '推送輿情',
    reprintQuery: '轉載查詢',
    collection: '收藏貼文',
    hotWeibo: '微博熱點',
    hotWechat: '微信熱點',
    hotDouyin: '抖音熱點',
    hotBilibili: 'B站熱點',
    onlineUsers: '線上使用者',
    dailyReport: '日報',
    weeklyReport: '週報',
  },
  monitor: {
    title: '監測管理',
    addGroup: '新增方案組',
    editGroup: '編輯方案組',
    deleteGroup: '刪除方案組',
    addProject: '新增方案',
    editProject: '編輯方案',
    deleteProject: '刪除方案',
    groupName: '方案組名稱',
    projectName: '方案名稱',
    projectType: '方案類型',
    normal: '普通',
    advanced: '進階',
    subjectWord: '主體詞',
    characterWord: '人物詞',
    eventWord: '事件詞',
    regionalWord: '地域詞',
    stopWord: '遮蔽詞',
    projectDescription: '方案描述',
    selectProject: '請從監測管理頁面選擇一個項目',
    deleteConfirm: '確定要刪除嗎？',
    groupDeleteConfirm: '刪除該方案組將同時刪除組下所有方案，是否繼續？',
    dataList: '資料監測',
    articleTitle: '文章標題',
    sourceName: '來源',
    publishTime: '發布時間',
    emotion: '情感',
    positive: '正面',
    neutral: '中性',
    negative: '負面',
    similarCount: '相似數',
    sourcePlatform: '來源平台',
    keyword: '關鍵詞',
    timeRange: '時間範圍',
    hours24: '24小時',
    today: '今天',
    yesterday: '昨天',
    days3: '3天',
    days7: '7天',
    days15: '15天',
    days30: '30天',
    days365: '1年',
    custom: '自訂',
    emotionFilter: '情感篩選',
    sourceFilter: '來源篩選',
    sortBy: '排序方式',
    timeDesc: '時間降序',
    timeAsc: '時間升序',
    similarDesc: '相似數倒序',
    matchMode: '匹配方式',
    fullText: '全文',
    titleOnly: '標題',
    contentOnly: '正文',
    preciseFilter: '精準篩選',
    mergeSimilar: '合併相似',
    sourcePlatforms: '監測來源平台',
    sourcePlatformsHint: '選擇需要監測的來源平台',
    platformsCount: '個平台',
    projectPlatforms: '項目平台',
    sourcePlatformFilter: '來源平台',
  },
  analysis: {
    title: '監測分析',
    dataOverview: '資料概覽',
    emotionalProportion: '情感佔比',
    planWordHit: '方案命中主體詞',
    keywordEmotionTrend: '關鍵詞情感分析走勢',
    hotEventRanking: '熱點事件排名',
    highwordCloud: '關鍵詞高頻分布統計',
    keywordIndex: '高頻詞指數',
    mediaActivity: '媒體活躍度分析',
    hotSpotRanking: '熱點地區排名',
    dataSourceDistribution: '資料來源分布',
    dataSourceAnalysis: '資料來源分析',
    keywordExposureRank: '關鍵詞曝光度環比排行',
    selfmediaVolumeRank: '自媒體渠道聲量排名',
    popularInformation: '熱門資訊',
    popularEvent: '熱點事件',
    hotCompany: '熱點公司',
    hotPeople: '熱點人物',
    hotSpot: '熱點地區',
    relativeNews: '相關資訊',
    categoryRank: '分類趨勢',
    industrialDistribution: '行業分布',
    eventStatistics: '事件統計',
    keywordEmotionStatistical: '關鍵詞情感分析資料統計分布',
    timePeriod: '時間週期',
    update: '更新分析',
    totalArticles: '文章總量',
    newsCount: '資訊數量',
    socialCount: '社交數量',
  },
  volume: {
    title: '聲量監測',
    totalVolume: '總聲量',
    newsVolume: '新聞聲量',
    socialVolume: '社交聲量',
    keywordEmotionStatistical: '關鍵詞情感分析資料統計分布',
    keywordSourceDistribution: '關鍵詞資料來源分布',
    keywordNewsRank: '關鍵詞資訊數量排名',
    topicClusterAnalysis: '主題觀點聚類分析',
    keywordEmotionTrend: '關鍵詞情感分析資料走勢',
    highwordCloud: '關鍵詞高頻分布統計',
    keywordExposureRank: '關鍵詞曝光度環比排行',
    keywordCorrelationNews: '熱點內容聚類分析排名',
    userPortraitLabel: '使用者畫像標籤',
    socialUserVolumeRank: '社交網路使用者聲量排名',
    mediaUserVolumeRank: '自媒體使用者聲量排名',
  },
  publicOption: {
    title: '事件分析',
    addEvent: '建立事件',
    editEvent: '編輯事件',
    deleteEvent: '刪除事件',
    eventName: '任務名稱',
    eventKeywords: '任務關鍵詞',
    eventStartTime: '開始時間',
    eventEndTime: '結束時間',
    eventStopWords: '遮蔽詞',
    reportList: '報告列表',
    reportDetail: '研判分析詳情',
    backAnalysis: '溯源分析',
    eventContext: '事件脈絡',
    eventTrace: '事件追蹤',
    hotAnalysis: '熱點分析',
    netizensAnalysis: '重點網民分析',
    statistics: '統計',
    propagationAnalysis: '傳播分析',
    thematicAnalysis: '專題分析',
    unscrambleContent: '內容解讀',
    judicialOpinion: '司法輿情分析研判',
    statusCreating: '正在建立',
    statusFailed: '建立失敗',
    statusSuccess: '建立成功',
  },
  report: {
    title: '分析報告',
    dailyReport: '日報',
    weeklyReport: '週報',
    monthlyReport: '月報',
    reportName: '報告名稱',
    reportType: '報告類型',
    reportPeriod: '報告週期',
    reportStatus: '報告狀態',
    generating: '已生成任務',
    editing: '正在編製',
    completed: '編製成功',
    failed: '編製失敗',
    deleteSelected: '批次刪除',
    compile: '編製',
    viewDetail: '查看詳情',
    dataOverview: '資料概覽',
    emotionAnalysis: '情感分析',
    hotEventRanking: '熱點事件排名',
    mediaActivity: '媒體活躍度分析',
    selfMediaRanking: '自媒體熱度排名',
    highWordIndex: '高頻詞指數',
    hotSpotRanking: '熱點地區排名',
    netizenWordCloud: '網民高頻詞雲',
    mediaWordCloud: '媒體高頻詞雲',
    hotPeople: '熱點人物',
    hotSpots: '熱點地區',
    topicClustering: '主題觀點聚類分析',
    socialVRanking: '社交網路大V熱度排名',
  },
  settings: {
    title: '系統設定',
    warning: {
      title: '預警設定',
      warningName: '預警名稱',
      warningWord: '預警詞',
      warningSwitch: '預警開關',
      warningClassify: '來源類型',
      warningContent: '預警內容',
      allContent: '全部',
      sensitiveOnly: '僅敏感',
      warningMatch: '匹配方式',
      warningDeduplication: '預警去重',
      warningSource: '預警來源',
      systemPush: '系統推送',
      emailPush: '郵箱推送',
      receiveTime: '接收時間',
      weekendWarning: '週末預警',
      warningInterval: '預警間隔',
      realtime: '即時預警',
      scheduled: '定時預警',
      messageList: '預警訊息',
      edit: '編輯預警',
    },
    preference: {
      title: '偏好設定',
      timeRange: '時間範圍',
      preciseFilter: '精準篩選',
      emotion: '情感屬性',
      similar: '相似文章',
      sort: '資訊排序',
      matchMode: '匹配方式',
      dataSource: '資料來源',
      websiteName: '網站名稱',
      author: '作者名稱',
      organization: '涉及機構',
      categoryLabel: '文章分類',
      enterpriseType: '涉及企業',
      highTechType: '高科技型企業',
      policyLabel: '涉及政策',
      dataSourceType: '資料品類',
      eventIndex: '涉及事件',
      industryIndex: '涉及行業',
      province: '涉及省份',
      city: '涉及城市',
    },
    feedback: {
      title: '回饋建議',
      content: '您的回饋',
      submit: '提交回饋',
    },
  },
}

export default zhTW
